import React, { useRef, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import Header from './Pages/Header';
import Hero from './Pages/Hero';
import Transport from './Pages/Transport';
import Booking from './Pages/Booking';
import Accommodation from './Pages/Accommodation';
import Contact from './Pages/Contact';
import Chatbot from './Pages/Chatbot';
import Privacy from './Pages/Privacy';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';


const SITE_URL = 'https://v2vlogistic.co.za';

const PAGE_SEO = {
  '/': {
    title: 'Student Transport Vaal to Venda & NSFAS Accommodation | V2V',
    description: 'Safe, affordable student transport between the Vaal, Venda and Gaza, plus NSFAS-accredited accommodation near VUT, NWU and Sedibeng. Book your seat online.'
  },
  '/accommodation': {
    title: 'NSFAS Student Accommodation in Vanderbijlpark | V2V',
    description: 'Find NSFAS-accredited student accommodation in Vanderbijlpark near VUT, NWU and Sedibeng. Compare residences, photos and features, then enquire on WhatsApp.'
  },
  '/contact': {
    title: 'Contact V2V Student Transport & Accommodation',
    description: 'Contact V2V on WhatsApp or email about student transport bookings and accommodation near VUT, NWU and Sedibeng.'
  },
  '/privacy': {
    title: 'Privacy Policy | V2V',
    description: 'How V2V Student Services collects, uses and protects your personal information under POPIA.'
  }
};

function App() {
  const transportRef = useRef(null);
  const bookingRef = useRef(null);
  const heroRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  // Page title, description and canonical address for Google
  useEffect(() => {
    const seo = PAGE_SEO[pathname] || PAGE_SEO['/'];
    document.title = seo.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', seo.description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', `${SITE_URL}${pathname}`);
  }, [pathname]);

  // Scroll to Transport section
  const handleTransport = () => {
    navigate('/');
    setTimeout(() => {
      transportRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  };

  // Scroll to Booking section
  const handleBookNow = () => {
    navigate('/');
    setTimeout(() => {
      bookingRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  };

  return (
    <>
      <Header handleTransport={handleTransport} handleBookNow={handleBookNow} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <div ref={heroRef}>
                <Hero handleTransport={handleTransport} handleBookNow={handleBookNow} />
              </div>
              <div ref={transportRef}><Transport /></div>
              <div ref={bookingRef}><Booking /></div>
            </>
          }
        />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>

      <Footer />

      {/* WhatsApp button */}
      <FloatingWhatsApp />

      <Chatbot handleBookNow={handleBookNow} />

      
    </>
  );
}

export default App;